export class Testassessment {
    FreelancerTestAssesment: string;
    UpdateTestAssesmentAPI: any;
    getFreelancertestfileAPI: string;
    getFreelancerUploadedTestFileDownload: string;

}
